import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate, Outlet } from "react-router-dom";

export default function AdminHome() {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#f2f2f2" }}>
      {/* DASHBOARD BUTTONS */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: 4,
        }}
      >
        <Typography variant="h5" fontWeight="bold" mb={4}>
          Admin Panel
        </Typography>

        <Button
  fullWidth
  sx={btnStyle}
  onClick={() => navigate("homepage-banner")}
>
  Manage Homepage Banner
</Button>


        <Button
          fullWidth
          sx={btnStyle}
          onClick={() => navigate("calendar")}       // ✅ RELATIVE ROUTE
        >
          Update Calendar
        </Button>

        <Button
          fullWidth
          sx={btnStyle}
          onClick={() => navigate("manage-upload")}       // ✅ RELATIVE ROUTE
        >
          Manage Uploads
        </Button>

        <Button fullWidth sx={btnStyle} disabled>
          Push Notification
        </Button>

      
      </Box>

      {/* CHILD ROUTES RENDER HERE */}
      <Box sx={{ mt: 4, px: 2 }}>
        <Outlet />   {/* ✅ THIS IS CRITICAL */}
      </Box>
    </Box>
  );
}

const btnStyle = {
  maxWidth: "320px",
  backgroundColor: "#1e88e5",
  color: "#fff",
  fontWeight: "600",
  py: 1.6,
  mb: 2,
  borderRadius: "12px",
  textTransform: "uppercase",
  "&:hover": {
    backgroundColor: "#1565c0",
  },
};
